import React, {useState} from 'react';
import {useLocation, useHistory} from 'react-router-dom';

import CustomModal from '../../../../../../elements/CustomModal/CustomModal';
import OpenConversationForm from './OpenConversation/OpenConversationForm';
import {makeStyles, Typography} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  title: {
    fontSize: '1.25rem',
    fontWeight: 600,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(2),
  },
}));

export default function OpenConversationFromSearchParams() {
  const classes = useStyles();

  const location = useLocation();
  const history = useHistory();

  const searchParams = new URLSearchParams(location.search);

  const identifier = searchParams.get('identifier');
  const firstName = searchParams.get('firstName') ?? '';
  const lastName = searchParams.get('lastName') ?? '';

  const message = searchParams.get('message');
  const decodedMessage = decodeURIComponent(message || '');

  const [modalOpen, setModalOpen] = useState(true);

  const handleSubmit = () => {
    window.location.reload();
  };

  const handleClose = () => {
    history.push('/chat/multi-chat');
    setModalOpen(false);
  };

  return (
    <CustomModal open={modalOpen} onClose={handleClose}>
      <Typography className={classes.title}>
        No tienes una conversación abierta con este contacto
      </Typography>
      <OpenConversationForm
        onSubmitSuccess={handleSubmit}
        defaultValue={{
          phoneNumber: identifier,
          firstName,
          lastName,
          message: decodedMessage,
        }}
      />
    </CustomModal>
  );
}
